import { render, staticRenderFns } from "./RicaviListTable.vue?vue&type=template&id=62d4fb32&"
import script from "./RicaviListTable.vue?vue&type=script&lang=js&"
export * from "./RicaviListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports